/** Scan decision for FR-CON-002 verify QR — pure, unit-tested, fail-closed. */

import { decodeVerifyQr, normalizeSafetyDigits } from "@veto/domain";

export type ScanClassification = "match" | "mismatch" | "notverify";

/**
 * Classify a scanned QR payload against the locally computed safety number.
 * The digits can only match if both devices derived them from the same keys —
 * anything else (foreign QR, wrong number, tampered payload) must never verify.
 */
export function classifyScan(raw: string, expectedDigits: string): ScanClassification {
  const digits = decodeVerifyQr(raw);
  if (digits === null) return "notverify";
  if (digits === normalizeSafetyDigits(expectedDigits)) return "match";
  return "mismatch";
}
